import React from 'react';

import './login.css';

const LoginFooter = () => (
  <div styleName="login-footer">
    <a
      styleName="login-footer-element"
      target="_blank"
      href="https://atom-ai.com/terms-of-service/"
    >
      Terms of Service
    </a>
    <a
      styleName="login-footer-element"
      target="_blank"
      href="https://atom-ai.com/privacy-policy/"
    >
      Privacy Policy
    </a>
    <a
      styleName="login-footer-element"
      target="_blank"
      href="https://atom-ai.com/"
    >
      Atom Website
    </a>
  </div>
);

export default LoginFooter;
